/**
 * This file holds methods responsible for manipulating webpacks public url at runtime to
 * locate chunked assets
 */

export const ensureTrailingSlash = path => (/\/$/.test(path) ? path : `${path}/`);

// eslint-disable-next-line no-undef
export const getPublicUrl = () => __webpack_require__.p;

export const setPublicUrl = (publicUrl) => {
  // eslint-disable-next-line no-undef
  __webpack_require__.p = ensureTrailingSlash(publicUrl);
};

const autoSetPublicUrl = () => {
  const mainScript = document.getElementById('jetstream-main');

  if (!mainScript) return;

  setPublicUrl(mainScript.src.replace(/shared-nav\..*js$/, ''));
};

export default autoSetPublicUrl;
